function printError(key, value) {
  if (!(value instanceof Error)) {
    return value;
  }
  const error = {};

  Object.getOwnPropertyNames(value).forEach(errorKey => {
    error[errorKey] = value[errorKey];
  });

  return error;
}

module.exports = printError;
